<template>
  <div>
    <div class="wrapper">
      <breadcrumb :crumbs="[$t('menu.suppliers'), $t('text.list')]">
        <el-button
          v-if="Permit.isFreeEdition()"
          type="success"
          size="mini"
          @click="create('jyAccount')"
          >+ {{ $t("text.create") }}</el-button
        >

        <el-dropdown
          v-if="
            Permit.currentUser().admin &&
            Permit.canActionsChargeEdition('supplierManage')
          "
          class="mgr10"
          @command="create"
        >
          <el-button type="success" size="mini">
            {{ $t("text.create") }}
            <i class="el-icon-caret-bottom el-icon--right" />
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="jyAccount">{{
              $t("customer.jyAccount")
            }}</el-dropdown-item>
            <el-dropdown-item command="nojyAccount">{{
              $t("customer.nojyAccount")
            }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </breadcrumb>
    </div>
    <div class="search with-narrows">
      <el-form
        :inline="true"
        @submit.native.prevent="search"
        :model="searchForm"
        size="small"
      >
        <el-form-item>
          <el-input
            v-model.trim="searchForm.keyword"
            :placeholder="$t('text.name')"
            size="small"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            native-type="submit"
          />
        </el-form-item>
      </el-form>
    </div>
    <div class="wrapper table-area">
      <sticky
        :sticky-top="50"
        :viewport="1024"
        :is-rem="false"
        style="min-height: 52px"
      >
        <vxe-toolbar ref="recordsToolbar" custom zoom class="table-toolbar">
          <template v-slot:buttons>
            <el-dropdown class="mgl10" @command="download">
              <el-button type="default" size="mini">
                {{ $t("action.download") }}
                <i class="el-icon-caret-bottom el-icon--right" />
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="checked">{{
                  $t("action.downLoadChecked")
                }}</el-dropdown-item>
                <el-dropdown-item command="search">{{
                  $t("action.downLoadSearch")
                }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <span class="pager-total">
              {{ $t("rules.pagerTotal", [pager.total]) }}
            </span>
          </template>
        </vxe-toolbar>
      </sticky>

      <vxe-table
        :data="records"
        @checkbox-change="setSelected"
        @checkbox-all="setSelected"
        :checkbox-config="{ reserve: true }"
        :loading="loading"
        id="stockInsTable"
        row-id="id"
        ref="recordsTable"
        class="recordsTable"
        size="mini"
        resizable
        round
        auto-resize
        highlight-hover-row
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column
          field="checkbox"
          type="checkbox"
          width="35"
        ></vxe-table-column>
        <vxe-table-column width="60px">
          <template v-slot="{ row, rowIndex }">
            <i
              v-if="rowIndex != 0"
              class="el-icon-top mgr10"
              @click="swapSequence(row, rowIndex, 'up')"
            ></i>
            <i
              v-if="
                rowIndex + 1 !=
                (pager.pageSize > pager.total ? pager.total : pager.pageSize)
              "
              class="el-icon-bottom"
              @click="swapSequence(row, rowIndex, 'down')"
            ></i>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="sequence"
          :title="$t('text.sequence')"
          width="50"
        />
        <vxe-table-column width="40">
          <template v-slot="{ row }">
            <!-- <img
              v-if="row.sourceTenantId != null"
              src="@/assets/jy.png"
              width="18px"
            /> -->
            <medal
              :year="row.sourceTenantRegYear"
              v-if="row.sourceTenantId != null"
            ></medal>
          </template>
        </vxe-table-column>
        <vxe-table-column field="name" :title="$t('text.name')" min-width="100">
          <template v-slot="{ row }">
            <span v-if="Permit.isFreeEdition()">{{ row.name }}</span>
            <span v-else class="blue" @click="showRow(row)">{{
              row.name
            }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="phone"
          :title="$t('courier.phone')"
          min-width="100"
        />
        <vxe-table-column
          v-if="!Permit.isFreeEdition()"
          field="replaceDeliver"
          :title="$t('supplier.replaceDeliver')"
          min-width="50"
        >
          <template v-slot="{ row }">
            <span v-if="row.replaceDeliver">{{ $t("boolean.true") }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="handCycle"
          :title="$t('supplier.handCycle')"
          min-width="100"
        />
        <vxe-table-column
          field="dailyCapacity"
          :title="$t('supplier.dailyCapacity')"
          min-width="100"
        />
        <vxe-table-column
          field="remark"
          :title="$t('text.remark')"
          min-width="100"
        >
          <template v-slot="{ row }">
            <raw-html-limit-number :content="row.remark" :number="16" />
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="hidden"
          :title="$t('supplier.hidden')"
          min-width="80"
        >
          <template v-slot="{ row }">
            <span v-if="row.hidden">{{ $t("boolean.true") }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="showSizeTemplate"
          :title="$t('supplier.showSizeTemplate')"
          min-width="80"
        >
          <template v-slot="{ row }">
            <span v-if="row.showSizeTemplate">{{ $t("boolean.true") }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="createAt"
          :title="$t('text.createAt')"
          width="110"
        />
        <vxe-table-column
          v-if="
            Permit.currentUser().admin && Permit.canActions('supplierManage')
          "
          field="action"
          :title="$t('text.action')"
          width="100"
        >
          <template v-slot="{ row, rowIndex }">
            <el-button type="text" size="mini" @click="edit(row, rowIndex)">{{
              $t("text.edit")
            }}</el-button>
            <el-button type="text" size="mini" @click="deleteRow(row)">{{
              $t("text.delete")
            }}</el-button>
          </template>
        </vxe-table-column>
      </vxe-table>

      <div class="flex flex-between pager">
        <div class="selected-qty-tips">
          选中了
          <span class="strong">{{ selectRecordQty }}</span>
          条记录
        </div>
        <div>
          <vxe-pager
            size="small"
            :loading="false"
            :background="false"
            :current-page="pager.currentPage"
            :page-size="pager.pageSize"
            :total="pager.total"
            :layouts="pagerConfig.layouts"
            :page-sizes="pagerConfig.pageSizes"
            @page-change="changePager"
          ></vxe-pager>
        </div>
      </div>
    </div>

    <!-- 编辑供应商 -->
    <el-dialog
      :title="$t('rules.edit', [$t('menu.suppliers')])"
      :close-on-click-modal="false"
      :visible.sync="editDF"
      width="60%"
    >
      <el-form ref="editObjForm" :model="editObj" label-width="100px">
        <fieldset class="mgb15">
          <legend>{{ $t("text.baseInfo") }}</legend>
          <el-row>
            <el-col :span="8">
              <el-form-item
                :label="$t('user.name')"
                :prop="'name'"
                :rules="[
                  {
                    required: true,
                    message: $t('rules.required', [$t('user.name')]),
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input size="small" v-model.trim="editObj.name" />
              </el-form-item>
            </el-col>
            <el-col v-if="!Permit.isFreeEdition()" :span="8">
              <el-form-item :label="$t('supplier.replaceDeliver')">
                <el-checkbox
                  size="small"
                  v-model="editObj.replaceDeliver"
                ></el-checkbox>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="$t('text.sequence')"
                :prop="'sequence'"
                :rules="[
                  {
                    required: true,
                    validator: validateSequenceEdit,
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input size="small" v-model.trim="editObj.sequence" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item
                :label="$t('tenant.country')"
                :prop="'country'"
                :rules="[
                  {
                    required: true,
                    message: $t('rules.required', [$t('text.name')]),
                    trigger: 'blur',
                  },
                ]"
              >
                <el-select
                  size="small"
                  v-model="editObj.country"
                  filterable
                  clearable
                >
                  <el-option
                    v-for="country in countries"
                    :key="country"
                    :label="$t('countries.' + country)"
                    :value="country"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('tenant.province')" :prop="'province'">
                <el-input size="small" v-model.trim="editObj.province" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('tenant.city')" :prop="'city'">
                <el-input size="small" v-model.trim="editObj.city" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="16">
              <el-form-item :label="$t('tenant.address')" :prop="'address'">
                <el-input size="small" v-model.trim="editObj.address" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="$t('supplier.handCycle')"
                :prop="'handCycle'"
              >
                <el-input size="small" v-model.trim="editObj.handCycle" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="16">
              <el-form-item :label="$t('supplier.url')" :prop="'url'">
                <el-input size="small" v-model.trim="editObj.url" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="$t('supplier.dailyCapacity')"
                :prop="'dailyCapacity'"
              >
                <el-input size="small" v-model.trim="editObj.dailyCapacity" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label-width="0">
                <el-checkbox v-model="editObj.showTerminalInfo">
                  {{ $t("supplier.showTerminalInfo") }}
                </el-checkbox>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('supplier.hidden')">
                <el-checkbox
                  size="small"
                  v-model="editObj.hidden"
                ></el-checkbox>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('supplier.showSizeTemplate')">
                <el-checkbox
                  size="small"
                  v-model="editObj.showSizeTemplate"
                ></el-checkbox>
              </el-form-item>
            </el-col>
          </el-row>
        </fieldset>
        <fieldset class="mgb15">
          <legend>{{ $t("text.remark") }}</legend>
          <el-input
            size="small"
            v-model.trim="editObj.remark"
            type="textarea"
            :rows="3"
          />
        </fieldset>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="editDoing"
          size="small"
          @click="editSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="editDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>

    <!-- 新增供应商 -->
    <el-dialog
      :title="$t('rules.create', [$t('menu.suppliers')])"
      :close-on-click-modal="false"
      :visible.sync="addJYAccountDF"
      width="30%"
    >
      <el-form ref="addObjForm" :model="addObj">
        <el-form-item
          :prop="'phone'"
          :rules="[
            { required: true, validator: validatePhone, trigger: 'blur' },
          ]"
        >
          <el-input
            size="small"
            v-model.trim="addObj.phone"
            :placeholder="$t('prompt.createSupplierInput')"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="addDoing"
          size="small"
          @click="addSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="addJYAccountDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 新增供应商 nojyAccount -->
    <el-dialog
      :title="$t('rules.create', [$t('menu.suppliers')])"
      :close-on-click-modal="false"
      :visible.sync="addNoJYAccountDF"
      width="60%"
    >
      <el-form ref="addObjForm" :model="addObj" label-width="90px">
        <fieldset class="mgb15">
          <legend>{{ $t("text.baseInfo") }}</legend>
          <el-row>
            <el-col :span="8">
              <el-form-item
                :label="$t('user.phone')"
                :prop="'phone'"
                :rules="[
                  { required: true, validator: validatePhone, trigger: 'blur' },
                ]"
              >
                <el-input
                  size="small"
                  v-model.trim="addObj.phone"
                  @blur="blurPhone"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="$t('user.name')"
                :prop="'name'"
                :rules="[
                  {
                    required: true,
                    message: $t('rules.required', [$t('user.name')]),
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input size="small" v-model.trim="addObj.name"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('supplier.replaceDeliver')">
                <el-checkbox
                  size="small"
                  v-model="addObj.replaceDeliver"
                ></el-checkbox>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item
                :label="$t('tenant.country')"
                :prop="'country'"
                :rules="[
                  {
                    required: true,
                    message: $t('rules.required', [$t('text.name')]),
                    trigger: 'blur',
                  },
                ]"
              >
                <el-select
                  size="small"
                  v-model="addObj.country"
                  filterable
                  clearable
                >
                  <el-option
                    v-for="country in countries"
                    :key="country"
                    :label="$t('countries.' + country)"
                    :value="country"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('tenant.province')" :prop="'province'">
                <el-input size="small" v-model.trim="addObj.province" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('tenant.city')" :prop="'city'">
                <el-input size="small" v-model.trim="addObj.city" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="16">
              <el-form-item :label="$t('tenant.address')" :prop="'address'">
                <el-input size="small" v-model.trim="addObj.address" />
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item :label="$t('supplier.showSizeTemplate')">
                <el-checkbox
                  size="small"
                  v-model="addObj.showSizeTemplate"
                ></el-checkbox>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="16">
              <el-form-item :label="$t('supplier.url')">
                <el-input size="small" v-model.trim="addObj.url" />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('supplier.hidden')">
                <el-checkbox size="small" v-model="addObj.hidden"></el-checkbox>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label-width="0">
                <el-checkbox v-model="addObj.showTerminalInfo">
                  {{ $t("supplier.showTerminalInfo") }}
                </el-checkbox>
              </el-form-item>
            </el-col>
          </el-row>
        </fieldset>
        <fieldset class="mgb15">
          <legend>{{ $t("text.remark") }}</legend>
          <el-input
            size="small"
            v-model.trim="addObj.remark"
            type="textarea"
            :rows="3"
          />
        </fieldset>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="addDoing"
          size="small"
          @click="addSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="addNoJYAccountDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>

    <drawer
      :title="$t('text.view')"
      :visible.sync="showDF"
      size="900px"
      direction="rtl"
      :wrapper-closable="false"
      :destroy-on-close="true"
    >
      <show :id="currentRowId" />
    </drawer>
  </div>
</template>
<script>
import Util from "@/utils";
import { page, table } from "@/utils/mixins.js";
import { countries } from "@/utils/enums.js";
import Medal from "@/components/Medal";
import Show from "./show";
import User from "@/api/user.js";
import Supplier from "@/api/supplier.js";
//
export default {
  mixins: [
    page,
    table.pager,
    table.narrow,
    table.search,
    table.checker,
    table.sorter,
    table.basic,
  ],
  components: {
    Medal,
    Show,
  },
  data() {
    var validatePhone = (rule, value, callback) => {
      const self = this;
      if (value == null || value.trim() === "") {
        callback(new Error(self.$t("rules.required", [self.$t("user.phone")])));
        return;
      }
      Supplier.findByPhone({ phone: value }).then(function (res) {
        if (res.data.code === 200) {
          callback(new Error(self.$t("prompt.hasBeenAdded")));
          return;
        } else {
          User.findByPhone({ phone: value }).then(function (res) {
            if (self.selectType === "jyAccount") {
              if (res.data.code === 200) {
                if (
                  res.data.entity.tenantId === self.Permit.currentTenant().id
                ) {
                  callback(new Error(self.$t("prompt.notAddOneself")));
                  return;
                } else if (res.data.entity.admin === false) {
                  callback(new Error(self.$t("prompt.notAddSubaccounts")));
                  return;
                } else {
                  self.addObj.name = res.data.entity.tenant.placeName;
                  self.addObj.country = res.data.entity.tenant.country;
                  self.addObj.province = res.data.entity.tenant.province;
                  self.addObj.city = res.data.entity.tenant.city;
                  self.addObj.address = res.data.entity.tenant.address;
                  callback();
                }
              } else {
                callback(new Error(self.$t("prompt.noAccount")));
                return;
              }
            } else {
              if (res.data.code === 200) {
                callback(new Error(self.$t("prompt.hasAccount")));
                return;
              } else {
                callback();
              }
            }
          });
        }
      });
    };
    var validateSequenceEdit = (rule, value, callback) => {
      const self = this;
      if (value === null || value === "") {
        callback(
          new Error(this.$t("rules.required", [this.$t("text.sequence")]))
        );
        return;
      }
      if (!Util.regexQuantity(value)) {
        callback(new Error(this.$t("rules.regex", [this.$t("text.sequence")])));
        return;
      }
      Supplier.findBySequence({ sequence: value }).then(function (res) {
        if (res.data.code === 200 && res.data.entity.id != self.row.id) {
          callback(
            new Error(self.$t("rules.exist", [self.$t("text.sequence")]))
          );
        } else {
          callback();
        }
      });
    };

    return {
      countries: countries,
      initFilter: null,
      searchForm: {
        keyword: null,
      },
      sorter: {
        sortBy: "suppliers_sequence",
        sortIndicator: "desc",
      },
      users: [],
      validateSequenceEdit: validateSequenceEdit,
      row: null,
      rowIndex: null,
      editDF: false,
      editObj: {
        serialNo: null,
        phone: null,
        name: null,
        country: null,
        province: null,
        city: null,
        address: null,
        remark: null,
        url: null,
        sourceTenantId: null,
        sequence: null,
        replaceDeliver: null,
        handCycle: null,
        dailyCapacity: null,
        showTerminalInfo: null,
        hidden: null,
        showSizeTemplate: null,
      },
      editDoing: false,
      // 新增
      validatePhone: validatePhone,
      selectType: null,
      addJYAccountDF: false,
      addNoJYAccountDF: false,
      addObj: {
        name: null,
        phone: null,
        country: null,
        province: null,
        city: null,
        address: null,
        remark: null,
        url: null,
        replaceDeliver: false,
        hidden: null,
        showSizeTemplate: null,
      },
      addDoing: false,
      //
      currentRowId: null,
      showDF: false,
    };
  },
  computed: {
    implicit() {
      return {
        deleteAt: "no",
      };
    },
  },
  created() {
    const self = this;
    this.$nextTick(() => {
      // 手动将表格和工具栏进行关联
      this.$refs.recordsTable.connect(this.$refs.recordsToolbar);
    });
    self.initFilter = self.$route.query.initFilter;
    User.findByTenantId(self.Permit.currentTenant().id).then(function (res) {
      if (res.status === 200) {
        self.users = res.data.filter((u) => u.authorize === true);
      } else {
        self.sysError();
      }
    });
  },
  methods: {
    swapSequence(row, rowIndex, type) {
      const self = this;
      const obj = {
        swapId: row.id,
        swapId2:
          type == "up"
            ? self.records[rowIndex - 1].id
            : self.records[rowIndex + 1].id,
      };
      Supplier.swapSequence(obj).then(function (res) {
        if (res.status == 200) {
          self.loadData();
        } else {
          self.sysError();
        }
      });
    },
    showRow(row) {
      this.currentRowId = row.id;
      this.showDF = true;
    },
    // 下载
    download(type) {
      const self = this;
      if (type == "checked") {
        if (!self.downloadChecked(self.selectRecords)) {
          return;
        }
        const data = {
          currentPage: 1,
          pageSize: self.limitNumber(),
          ids: self.selectRecords.map((c) => c.id),
        };
        self.downloadData(data);
      } else {
        if (!self.downloadSearch(self.pager.total)) {
          return;
        }
        const data = JSON.parse(JSON.stringify(self.combineParams()));
        data.pageSize = self.limitNumber();
        self.downloadData(data);
      }
    },
    downloadData(data) {
      const self = this;
      Supplier.exportExcel(data).then(function (res) {
        if (res.data.code === 200) {
          self.$message({
            message: self.$t("prompt.downloadPrompt"),
            type: "success",
          });
          self.loadData();
          self.$eventHub.$emit("emitDownLoad");
        } else {
          self.$message.error(self.$t("prompt.downloadErr"));
        }
      });
    },

    // 新增
    create(type) {
      this.selectType = type;
      this.addObj.phone = null;
      this.addObj.name = null;
      this.addObj.country = null;
      this.addObj.province = null;
      this.addObj.city = null;
      this.addObj.address = null;
      this.addObj.remark = null;
      this.addObj.replaceDeliver = false;
      this.addObj.hidden = false;
      this.addObj.showSizeTemplate = false;
      if (this.selectType === "jyAccount") {
        this.addJYAccountDF = true;
      } else {
        this.addNoJYAccountDF = true;
      }
      this.saveDoing = false;
    },
    blurPhone() {},
    addSubmit() {
      const self = this;
      this.$refs.addObjForm.validate((valid) => {
        if (valid) {
          self.addDoing = true;
          Supplier.create(self.addObj).then(function (res) {
            self.addDoing = false;
            self.addJYAccountDF = false;
            self.addNoJYAccountDF = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.addSuccess"),
                type: "success",
              });
              self.loadData();
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },

    // 删除
    deleteRow(row) {
      const self = this;
      if (confirm(this.$t("prompt.confirmDelete"))) {
        Supplier.delete(row.id).then(function (res) {
          if (res.status === 200) {
            self.$message({
              message: self.$t("prompt.delSuccess"),
              type: "success",
            });
            self.loadData();
          } else {
            self.sysError();
          }
        });
      }
    },
    // 编辑
    edit(row, rowIndex) {
      this.row = row;
      this.rowIndex = rowIndex;
      this.editObj.phone = row.phone;
      this.editObj.name = row.name;
      this.editObj.country = row.country;
      this.editObj.province = row.province;
      this.editObj.city = row.city;
      this.editObj.address = row.address;
      this.editObj.remark = row.remark;
      this.editObj.sourceTenantId = row.sourceTenantId;
      this.editObj.replaceDeliver = row.replaceDeliver;
      this.editObj.url = row.url;
      this.editObj.showTerminalInfo = row.showTerminalInfo;
      this.editObj.sequence = row.sequence;
      this.editObj.showSizeTemplate = row.showSizeTemplate;
      this.editObj.hidden = row.hidden;
      this.editDoing = false;
      this.editDF = true;
    },
    editSubmit() {
      const self = this;
      self.$refs.editObjForm.validate((valid) => {
        if (valid) {
          self.editDoing = true;
          Supplier.update(self.row.id, self.editObj).then(function (res) {
            self.editDoing = false;
            self.editDF = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.editSuccess"),
                type: "success",
              });
              self.loadData();
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },

    dataProvider(params) {
      return Supplier.search(params);
    },
  },
};
</script>
